import LocalStorageConst from '../../constant/localstorage.constant';

export const removeKeyValueFromLocalStorage = (key) => {
  if (key) {
    return localStorage.removeItem(LocalStorageConst.prefix + key);
  }
  return null;
};
